import { createFileRoute } from "@tanstack/react-router";

import ScanAnalysis from "~/pages/MeqLiveAdmin/ScanAnalysis";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-live-admin/scan-analysis")({
  staticData: ROUTE_STATIC.meqLiveAdmin,
  component: ScanAnalysis,
});
